import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { PropertyLookupHttpService } from './property-lookup.http.service';
import { LookupStore } from '../lookup.store';
import { PropertyLookupSummary } from '../../models/property-lookup-summary';
import { PropertyLookupDetail } from '../../models/property-lookup-detail';
import { LogService } from '../../log/log.service';
import { FlashMessagesService } from '../../flash-messages/service/flash.messages.service';

@Injectable()
export class PropertyLookupStore implements LookupStore<PropertyLookupSummary, PropertyLookupDetail> {

  private mySelectedResults: Subject<PropertyLookupDetail> = new Subject();
  private mySearchResults: BehaviorSubject<List<PropertyLookupSummary>> = new BehaviorSubject(List([]));

  constructor(private propertyLookupService: PropertyLookupHttpService,
              private logService: LogService,
              private flashMessagesService: FlashMessagesService) {
  }

  get selected(): Observable<PropertyLookupDetail> {
    return this.mySelectedResults.asObservable().share();
  }

  get searchResults(): Observable<List<PropertyLookupSummary>> {
    return this.mySearchResults.asObservable().share();
  }

  clearSearchResults(): void {
    this.mySearchResults.next(List([]));
  }

  search(searchText: string): Observable<List<PropertyLookupSummary>> {
    this.logService.debug(`searchText: ${searchText}`);

    return this.propertyLookupService.search(searchText)
      .catch((error: any) => {
        this.flashMessagesService.warn('MESSAGES.ERROR.PROPERTY_LOOKUP_SEARCH', `Error retrieving PropertyLookupSearch: ${error}`);
        return Observable.throw(error);
      })
      .map((res: List<PropertyLookupSummary>) => {
        this.mySearchResults.next(res);
        return res;
      });
  }

  getDetail(summaryRecord: PropertyLookupSummary): Observable<PropertyLookupDetail> {
    this.logService.debug(`summaryRecord: ${JSON.stringify(summaryRecord)}`);

    return this.propertyLookupService.getDetail(summaryRecord)
      .catch((error: any) => {
        this.flashMessagesService.error('MESSAGES.ERROR.PROPERTY_LOOKUP_GET_DETAILS', `Error retrieving PropertyLookupDetail: ${error}`);
        return Observable.throw(error);
      })
      .map((res: PropertyLookupDetail) => {
        this.mySelectedResults.next(res);
        return res;
      });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/lookup/property-lookup/property-lookup.store.ts